import React from 'react';
import { useRecoilState } from 'recoil';

import Modal from '@/ui-components/Modal';
import Panel, { PanelClose } from '@/ui-components/Panel';
import Typography from '@/ui-components/Typography';
import Button from '@/ui-components/Button';

import useBem from '@/use/useBem';
import { pendingPopupsState } from '@/framework/user/pendingPopupsState';
import * as rewardsApi from '@/api/rewards.service';

const RewardPopup = () => {
  const [pendingPopups, setPendingPopups] = useRecoilState(pendingPopupsState);
  const { bem } = useBem('reward-popup');

  const reward = pendingPopups.find((popup) => popup.type === 'reward');
  const isOpen = Boolean(reward);

  const handleDismiss = async () => {
    if (!reward) {
      return;
    }

    const slug = reward.slug;

    try {
      await rewardsApi.markPopupsSeen([slug]);
      setPendingPopups((prev) => prev.filter((popup) => popup.slug !== slug));
    } catch {
      // keep popup visible on failure
    }
  };

  if (!reward) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={handleDismiss}>
      <Panel className={bem('')}>
        <PanelClose onClick={handleDismiss} />
        {reward.title && (
          <Typography className={bem('h')} variant="l" component="div">
            {reward.title}
          </Typography>
        )}
        {reward.description && <Typography>{reward.description}</Typography>}
        <Button onClick={handleDismiss}>Nice</Button>
      </Panel>
    </Modal>
  );
};

export default RewardPopup;
